// $.fn.dataTable.ext.errMode = 'none';

PJQ.views.dataTables = {};

PJQ.views.dataTables.DataTable = PJQ.views.BaseView.extend({
    baseOptions: {
        template: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Base'),
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Data-Table-Header-Base')
        },
        deferRender: true,
        isStriped: false,
        isNoPadding: true,
        isOverflowAuto: false,
        isHideSearch: false,
        dom: "<'row no-gutters'<'table-outer col-sm-12'tr>>" + "<'row no-gutters'<'col-sm-5 mt-1'l><'col-sm-7 mt-2'p>>",
        headerData: {},
        getPageCallback: null,
        onRowClick: null,
        onRowDoubleClick: null,
        onRowRemoved: null,
        onTableDraw: null,
        minHeightPx: null,
        paging: true,
        pageLength: 10,
        rowId: "cid",
        groupBy: null,
        groupByKey: null,
        disableGroupToggle: null,
        getGroupHeader: null,
        collapsedGroups: [],
        scrollRows: false,
        emptyDataGroup: "N/A",
        onPageSizeChange: null,
        orderCookie: null,
        columnWidthCookie: null,
        pageLengthCookie: null,
        showPageSelector: false,
        enableColumnResize: false,
        hasFooter: false,
        extraClasses: null,
        toggleRowClass: '.toggle-row',
        hideColumnHeaders: false
    },
    defaultEvents: {
        'click .group-start': 'toggleGroup',
        'keyup .datatable-search': 'search',
        'click .clear-filters': 'clearFilters'
    },
    isColumnResizable: function (column) {
        return true;
    },
    onColumnResizeStart: function (column, columns) {

    },
    onColumnResize: function (column) {

    },
    onColumnResizeEnd: function (column, columns) {

    },
    beforeFirstRender: function () {
        this.options = _.extend(this.options, {
            uuid: _.uniqueId(),
            dom: this.options.paging ? this.options.dom : "<'row no-gutters'<'table-outer col-sm-12'tr>>",
            language: _.defaults({
                lengthMenu: "Show _MENU_",
                processing: "Loading...",
                paginate: {
                    previous: "Prev",
                    next: "Next"
                }
            }, this.options.language ? this.options.language : {})
        });

        if (this.options.clearServerCache)
            this.clearServerCache = true;
    },
    beforeRender: function () {
        if (_.size(this.options.groupByKey) > 0) {
            if (this.options.groupBy != null) {
                window.localStorage.removeItem(this.options.groupByKey);
                if (_.size(this.options.groupBy) > 0) {
                    window.localStorage.setItem(this.options.groupByKey, this.options.groupBy);
                }
            } else {
                let groupBy = window.localStorage.getItem(this.options.groupByKey);
                if (_.size(groupBy) > 0) {
                    this.options.groupBy = groupBy;
                }
            }
        }

        let grg = this.options.getRowGroup || this.getRowGroup,
            groupBy = this.getGroupBy();
        if (groupBy != null) {
            this.options.rowGroup = {
                startRender: _.bind(this.startGroupRender, this),
                emptyDataGroup: this.options.emptyDataGroup ? this.options.emptyDataGroup : "N/A",
                dataSrc: (row) => {
                    if (typeof grg === 'function') {
                        return grg(row, groupBy);
                    }

                    let groupByCol = this.getGroupByColumn();
                    if (groupByCol == null) {
                        return null;
                    }


                    let dataVal = PJQ.helpers.objectHelpers.getNestedValue(row, groupByCol.column.data ?? groupByCol.column.columnData ?? groupByCol.column.attribute);
                    if (typeof groupByCol.column.group === 'function') {
                        return groupByCol.column.group(row, groupBy);
                    } else if (typeof groupByCol.column.render === 'function') {
                        return groupByCol.column.render(dataVal, "display", row);
                    }

                    return dataVal ?? '';
                }
            };
        }
    },
    renderData: function () {
        return {
            options: this.options
        };
    },
    getContextMenuOptions: function () {
        return this.options.contextMenuOptions != null ? this.options.contextMenuOptions : null;
    },
    getSortableOptions: function () {
        return this.options.sortableOptions != null ? this.options.sortableOptions : null;
    },
    afterRender: function () {
        this.renderHeader();

        let self = this,
            doneMoving = true;
        self.$el.off('dblclick');
        self.$el.on('touchmove', 'tbody tr[id]', function () {
            doneMoving = false;
        });

        self.$el.on('click', 'tbody tr[id]', function (e) {
            let row = self.getRow($(this));
            if (row) {
                if (doneMoving) {
                    self.onRowClick(row);
                }
            }
        });
        self.$el.on('dblclick touchend', 'tbody tr[id]', function (e) {
            let row = self.getRow($(this)),
                $target = $(e.target);

            if (_.size(self.options.toggleRowClass) > 0 && $target.is(self.options.toggleRowClass)) {
                return;
            }

            if (row) {
                e.stopPropagation();
                if (doneMoving) {
                    self.onRowDoubleClick(row);
                }
            }
        });

        // self.$el.off('draw.dt');
        self.$el.on('draw.dt', function () {
            if (self.options.showPageSelector) {
                self.renderPageSelector();
            }
            self.onTableDraw();
        });

        // self.$el.on( 'error.dt', function ( e, settings, techNote, message ) {
        //     if(console){
        //         console.log( 'DataTable ' + this.options.uuid  + ' error: ', message );
        //     }
        // } ) .DataTable();

        this.renderDataTable();

        let sortOpts = this.getSortableOptions();
        if (_.size(sortOpts) > 0) {
            this.makeSortable(sortOpts);
        }

        let ctxOpts = this.getContextMenuOptions();
        if (ctxOpts != null && _.size(ctxOpts.actions) > 0) {
            this.addContextMenu(ctxOpts);
        }
    },
    renderPageSelector: function () {
        this.$('.page-select-span').remove();
        this.$('.dataTables_paginate').prepend('<span class="page-select-span"><select class="page-select wd-80p max-wd-80p"></select></span>');

        this.pageSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.page-select'),
            isIntChoices: true,
            defaultValue: this.dataTable.page(),
            onChange: _.bind(function (value) {
                this.dataTable.page(value).draw('page');
            }, this)
        });

        let options = '',
            pages = this.dataTable.page.info().pages;
        for (let num = 0; num < pages; num++) {
            options += '<option value="' + num + '">Page ' + (num + 1) + '</option>';
        }
        this.pageSelectPicker.$el.html(options);
        this.pageSelectPicker.refresh();
        this.dataTable.on('page', _.bind(function () {
            this.pageSelectPicker.setValue(this.dataTable.page())
        }, this));
    },
    onTableDraw: function () {
        let self = this;

        if (this.options.hideColumnHeaders) {
            this.$el.find('thead').attr('style', 'visibility: collapse;');
        }
        if (typeof this.options.onTableDraw === 'function') {
            this.options.onTableDraw(this.dataTable);
        }

        // this.updateScrollbar();
    },
    onRowClick: function (row) {
        if (typeof this.options.onRowClick === 'function') {
            this.options.onRowClick(row);
        }
    },
    onRowDoubleClick: function (row) {
        if (typeof this.options.onRowDoubleClick === 'function') {
            this.options.onRowDoubleClick(row);
        }
    },
    afterHeaderRender: function () {
        if (typeof this.options.afterHeaderRender === 'function') {
            this.options.afterHeaderRender(this, this.$('.dt-header'));
        }
    },
    beforeDataTableRender: function () {

    },
    headerData: function () {
        return typeof this.options.headerData === 'function' ? this.options.headerData() : this.options.headerData;
    },
    renderHeader: function () {
        if (!this.options.isHideSearch) {
            this.renderSubTemplate(false, this.options.subTemplates.header, this.$('.dt-header'), this.headerData(), _.bind(function () {
                this.delegateEvents();
                this.afterHeaderRender();
            }, this));
        }
    },
    renderPage: function () {
        if (this.dataTable != null) {
            let page = this.dataTable.page();
            this.options.displayStart = page != null ? page * this.options.pageLength : null;
        }
        if (this.options.addressBookView && this.options.addressBookView.currentView === 'company') {
            if (this.options.addressBookView.dataTable) {
                let page = this.options.addressBookView.dataTable.dataTable.page();
                this.options.addressBookView.dataTable.options.displayStart = page != null ? page * this.options.addressBookView.dataTable.options.pageLength : null;
                this.options.addressBookView.dataTable.options.addressBookView.dataTable.render()
            }
        } else {
            this.render();
        }
    },
    disableColumnReorder: function () {
        if (this.dataTable != null && this.dataTable.colReorder != null && typeof this.dataTable.colReorder.disable === 'function') {
            this.dataTable.colReorder.disable();
        }
    },
    enableColumnReorder: function () {
        if (this.dataTable != null && this.dataTable.colReorder != null && typeof this.dataTable.colReorder.enable === 'function') {
            this.dataTable.colReorder.enable();
        }
    },
    renderDataTable: function () {
        this.options.childDataTables = [];

        this.beforeDataTableRender();

        if (this.dataTable)
            this.dataTable.destroy();

        if (this.options.getPageCallback != null) {
            this.options = _.extend(this.options, {
                ajax: _.bind(this.getPage, this),
                processing: true,
                serverSide: true
            });
        }

        if (this.options.columns == null && typeof this.getColumns === 'function') {
            this.options.columns = this.getColumns();
        }

        this.colNameMap = {};
        _.each(this.options.columns, function (column, index) {
            if (_.size(column.title) > 0) {
                this.colNameMap[column.title.toLowerCase()] = index;
            }
        }, this);

        let rowIdAttr = this.options.rowId;
        this.$dataTable = this.$('#dt_' + this.options.uuid);

        if (this.options.pageLength === 0) {
            this.options.paging = false;
        }

        this.$el.off('order.dt');
        if (_.size(this.options.orderCookie) > 0) {
            let self = this;
            let cookieVal = PJQ.helpers.cookieHelpers.getCookie(self.options.orderCookie);
            if (_.size(cookieVal) > 0) {
                self.options.order = JSON.parse(cookieVal);

                if (self.options.order.length > 1) {
                    let firstVal = self.options.order[0];
                    if (!_.isArray(firstVal)) {
                        self.options.order = [self.options.order];
                    }
                }
            }

            self.$el.on('order.dt', _.bind(function (e, settings, details) {
                let orderArr = [];
                _.each(details, function (order) {
                    orderArr.push([order.col, order.dir]);
                });
                PJQ.helpers.cookieHelpers.setCookie(self.options.orderCookie, JSON.stringify(orderArr));
            }, this));
        }

        this.$el.off('length.dt');
        if (_.size(this.options.pageLengthCookie) > 0) {
            let self = this;
            let cookieVal = PJQ.helpers.cookieHelpers.getCookie(self.options.pageLengthCookie);
            if (_.size(cookieVal) > 0) {
                self.options.pageLength = parseInt(cookieVal);
            }

            self.$el.on('length.dt', _.bind(function (e, settings, details) {
                PJQ.helpers.cookieHelpers.setCookie(self.options.pageLengthCookie, details);
            }, this));
        }

        if (this.options.hasFooter) {
            if (typeof this.options.footer === 'function') {
                this.$dataTable.append(this.options.footer(this));
            } else {
                let colMarkup = '';
                _.each(typeof this.options.columns === 'function' ? this.options.columns() : this.options.columns, (column) => {
                    if (column.visible !== false) {
                        let col = '';
                        if (typeof column.renderFooter === 'function') {
                            col = column.renderFooter(this.options.data);
                        }
                        colMarkup += '<th>' + (col ?? '') + '</th>';
                    }
                })
                this.$dataTable.append('<tfoot><tr>' + colMarkup + '</tr></tfoot>');
            }
        }
        let self = this,
            filterData = this.getFilterData(),
            groupByCol = this.getGroupByColumn();
        if (groupByCol != null) {
            this.options.orderFixed = [[groupByCol.index, 'asc']];

            // if the group by column data is array data
            // we need to clone each object for each item in the array so items can be in multiple groups
            if (groupByCol.column != null && groupByCol.column.isArrayGroup && _.size(filterData) > 0) {
                let attr;
                if (groupByCol.column.attribute) {
                    attr = groupByCol.column.attribute
                } else if (typeof groupByCol.column.columnData) {
                    attr = groupByCol.column.columnData;
                } else {
                    attr = null;
                }
                if (_.size(attr) > 0) {
                    let newData = [];
                    _.each(filterData, function (item) {
                        let colData = typeof groupByCol.column.columnData === 'function' ? groupByCol.column.columnData(item) : item[attr];
                        if (_.size(colData) > 1) {
                            _.each(colData, function (colItem) {
                                if (typeof item.clone === 'function') {
                                    let newItem = item.clone();
                                    newItem.set(attr, [colItem]);
                                    newData.push(newItem);
                                } else {
                                    let newItem = _.clone(colItem);
                                    newItem[attr] = [colItem];
                                    newData.push(newItem);
                                }
                            });
                        } else {
                            newData.push(item);
                        }
                    });
                    filterData = newData;
                }
            }
        }

        this.dataTable = this.$dataTable.DataTable(_.defaults(
            {
                data: filterData,
                fixedHeader: {
                    header: this.options.scrollRows && this.options.parentDataTable == null,
                    footer: this.options.scrollRows && this.options.hasFooter
                },
                initComplete: function (settings, json) {
                    // Add a table wrapper for scroll-x. See updateScrollbar()
                    // this.wrap("<div class='table-wrapper'></div>");

                    if (typeof self.options.initComplete === 'function') {
                        self.options.initComplete.call(this, settings, json);
                    }
                },
                createdRow: _.bind(this.createdRow, this),
                rowId: function (a) {
                    let id = a[rowIdAttr];
                    return typeof id === 'number' ? id.toString() : id;
                }
            }, this.options));

        this.applyColumnWidths();

        if (this.options.enableColumnResize) {
            this.makeColumnsResizeable();
        }

        this.$dataTable.on('mouseup', function () {
            self.options.isResizing = false;
        });

        if (this.options.getPageCallback != null) {
            this.$dataTable.on('length.dt order.dt', _.bind(function () {
                this.clearServerCache = true;
            }, this));
        }

        let pageSizeContainer = this.$('.dataTables_length');
        if (_.size(pageSizeContainer) > 0) {
            pageSizeContainer.addClass('fs-14 text-dark');
            let pageSizeInput = pageSizeContainer.find('select');
            pageSizeInput.addClass('wd-80p mr-2');
            new PJQ.inputs.Selectpicker({
                el: pageSizeInput,
                isIntChoices: true,
                defaultValue: this.options.pageLength,
                onChange: _.bind(function (value) {
                    if (typeof this.options.onPageSizeChange === 'function') {
                        this.options.onPageSizeChange(value);
                    }
                }, this)
            });
        }

        this.$wrapper = this.$('#dt_' + this.options.uuid + '_wrapper');
        this.afterSearch();

        if (this.options.isOverflowAuto) {
            this.$wrapper.find('.row>.col-sm-12').first().addClass('of-x-auto')
        }

        if (_.size(this.options.orderFixed) > 0) {
            _.each(this.options.orderFixed, function (arr) {
                this.$dataTable.find('thead > tr > th[data-column-index="' + arr[0].toString() + '"]').addClass('hidden-before hidden-after');
            }, this)
        }

        let hasSettingsModel = this.options.settings != null,
            isBackboneSettings = this.options.settings instanceof Backbone.Model;
        this.$el.on('order.dt', _.bind(function (e, settings, details) {
            if (this.$dataTable.attr('id') !== $(e.target).attr('id')) {
                return;
            }

            e.stopPropagation();
            if (hasSettingsModel) {
                let oldOrderBy,
                    oldOrderAscending,
                    oldOrder = 0, columns = this.options.columns;
                if (isBackboneSettings) {
                    oldOrderBy = this.options.settings.get('orderBy');
                    oldOrderAscending = this.options.settings.get('orderAscending');
                } else {
                    oldOrderBy = this.options.settings.orderBy;
                    oldOrderAscending = this.options.settings.orderAscending;
                }

                _.each(columns, _.bind(function (column, index) {
                    if (column.columnData === oldOrderBy)
                        oldOrder = index;
                }, this));

                let detailCol = isBackboneSettings ? details[details.length - 1] : details[0],
                    orderByCol = columns[detailCol.src],
                    orderBy = orderByCol.columnData != null ? orderByCol.columnData : orderByCol.data,
                    orderAscending = (detailCol.dir === 'asc');
                if (oldOrderBy !== orderBy || oldOrderAscending !== orderAscending) {
                    if (isBackboneSettings) {
                        this.options.settings.set('orderBy', orderBy);
                        this.options.settings.set('orderAscending', orderAscending);
                        if (this.options.settings.hasEndpoint()) {
                            this.options.settings.save();
                        }
                    } else {
                        this.options.settings.orderBy = orderBy;
                        this.options.settings.orderAscending = orderAscending;
                    }
                    this.orderByChanged();
                }
            } else {
                this.orderByChanged(details);
            }
        }, this));

        if (this.options.colReorder != null) {
            this.$el.off('column-reorder.dt');
            this.$el.on('column-reorder.dt', _.bind(function (e, settings, details) {
                e.stopPropagation();
                if (details.drop || this.options.colReorder.realtime !== false) {
                    let columns = this.options.columns,
                        fixedLeft,
                        fixedRight;
                    if (typeof this.options.colReorder === 'object') {
                        fixedLeft = this.options.colReorder.fixedColumnsLeft > 0 ? this.options.colReorder.fixedColumnsLeft : 0;
                        fixedRight = this.options.colReorder.fixedColumnsRight > 0 ? this.options.colReorder.fixedColumnsRight : 0;
                    } else {
                        fixedLeft = 0;
                        fixedRight = 0;
                    }
                    _.each(columns, function (col, index) {
                        let curSort = col.sort != null ? col.sort : index;
                        col.sort = details.mapping[curSort];
                    });
                    if (this.options.settings != null) {
                        let newColumns = _.map(_.sortBy(_.filter(columns, function (column) {
                            let colNum = column.sort + 1;
                            return (colNum > fixedLeft && colNum <= _.size(columns) - fixedRight);
                        }), function (column) {
                            return column.sort;
                        }), function (column) {
                            return column.columnData;
                        });
                        if (isBackboneSettings) {
                            this.options.settings.set('columns', newColumns);
                            this.options.settings.save();
                        } else {
                            this.options.settings.columns = newColumns;
                        }
                        this.columnOrderChanged(newColumns);
                    }

                    this.columnOrderChanged(_.sortBy(columns, function (column) {
                        return column.sort;
                    }));
                }
            }, this));
        }

        if (_.size(this.options.toggleRowClass) > 0) {
            this.$el.off('click', this.options.toggleRowClass);
            this.$el.on('click', this.options.toggleRowClass, _.bind(this.childRowToggle, this));

            this.$el.off('click', '.toggle-all-rows');
            this.$el.on('click', '.toggle-all-rows', _.bind(this.toggleAllChildRows, this));
        }

        // Resize observer to update scrollbar when the table width changes. Calls updateScrollbar() when the table width changes
        // let resizeObserver = new ResizeObserver(entries => {
        //     for (let entry of entries) {
        //         if (entry.contentRect.width) {
        //             self.updateScrollbar();
        //         }
        //     }
        // });

        // Have resizeObserver observe the datatable element
        // if (this.$dataTable[0]) {
        //     resizeObserver.observe(this.$dataTable[0]);
        // }

        this.initializeToggledRows();
        this.afterDataTableRender();
    },
    makeColumnsResizeable: function () {
        let self = this,
            tableWidth = self.$dataTable.width(),
            minColumnWidth = 30;

        if (this.options.colReorder != null && this.options.enableColumnResize) {
            let settings = self.dataTable.settings()[0];
            if (settings == null) {
                return;
            }

            let internalColReorder = settings._colReorder;
            let colReorderMouseDown = $.fn.dataTable.ColReorder.prototype._fnMouseDown;

            this.$dataTable.find('thead th').off('mousedown.ColReorder touchstart.ColReorder');
            this.$dataTable.find('thead th').on('mousedown.ColReorder touchstart.ColReorder', function (e) {
                const offsetX = e.pageX - $(this).offset().left;

                if (offsetX > $(this).outerWidth() - 5) {
                    self.options.isResizing = true;
                } else {
                    self.options.isResizing = false;
                    colReorderMouseDown.call(internalColReorder, e, this);
                }
            });
        }

        self.$dataTable.find('thead').first().find('th').resizable({
            handles: "e",
            start: function (event, ui) {
                self.options.isResizing = true;

                self.$dataTable.find('thead th').each(function () {
                    this.addEventListener("click", self.preventBubble, {capture: true});
                });
                self.$dataTable.on('mouseup.preventBubble', self.preventBubble);

                self.columnWidths = [];
                self.$dataTable.find('thead').first().find('th').each(function () {
                    const width = $(this).width();
                    self.columnWidths.push(width);
                    $(this).css('width', width + 'px');
                });

                self.$dataTable.find('tbody').first().find('tr').each(function () {
                    $(this).find('td').each(function (i) {
                        $(this).css('width', self.columnWidths[i] + 'px');
                    });
                });

                self.$dataTable.css('width', tableWidth + 'px');
            },
            resize: function (event, ui) {
                let thIndex = $(this).index();
                let newWidth = ui.size.width;
                let currentTh = $(this);
                let nextTh = self.$dataTable.find('thead').first().find('th').eq(thIndex + 1);

                if (nextTh.length) {
                    let totalAvailableWidth = currentTh.width() + nextTh.width();
                    let remainingWidth = totalAvailableWidth - newWidth;

                    if (remainingWidth > minColumnWidth) {
                        currentTh.css('width', newWidth + 'px');
                        nextTh.css('width', remainingWidth + 'px');

                        self.$dataTable.find('tbody').first().find('tr').each(function () {
                            $(this).find('td').eq(thIndex).css('width', newWidth + 'px');
                            $(this).find('td').eq(thIndex + 1).css('width', remainingWidth + 'px');
                        });
                    } else {
                        currentTh.css('width', totalAvailableWidth - minColumnWidth + 'px');
                        nextTh.css('width', minColumnWidth + 'px');

                        self.$dataTable.find('tbody').first().find('tr').each(function () {
                            $(this).find('td').eq(thIndex).css('width', totalAvailableWidth - minColumnWidth + 'px');
                            $(this).find('td').eq(thIndex + 1).css('width', minColumnWidth + 'px');
                        });
                    }
                }
            },
            stop: function (event, ui) {
                self.saveColumnWidths();

                self.$dataTable.find('thead th').each(function () {
                    this.removeEventListener("click", self.preventBubble, {capture: true});
                });
                self.$dataTable.off('mouseup.preventBubble');

                self.options.isResizing = false;
            }
        });
    },
    updateScrollbar: function (context) {
        // This function exists because resizeable columns causes the table to be larger than its container, so it will always show a scroll bar if overflow-x is auto/scroll
        // This function will check if the table is bigger than the wrapper, and if it is, it will add a scrollbar to the wrapper
        // .table-wrapper is added in the initComplete function of the datatable
        let $wrapper = this.$wrapper,
            $table = this.$dataTable

        if (!$wrapper || !$table) {
            return;
        }

        // Don't add scrollbar if the table is nested inside another table, only the outer table should have the scrollbar
        let isNestedTable = $wrapper.closest('table').length > 0;

        // If the table is bigger than the wrapper, then add scrollbar
        if ($table.outerWidth() > $wrapper.width() && !isNestedTable) {
            $wrapper.css('overflow-x', 'auto');
        } else {
            $wrapper.css('overflow-x', 'visible');
        }
    },
    preventBubble: function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
    },
    saveColumnWidths: function () {
        let columnWidths = [],
            self = this;
        this.$dataTable.find('thead th').each(function () {
            let widthPercent = $(this).width() / self.$dataTable.width() * 100;
            columnWidths.push(widthPercent);
        });

        PJQ.helpers.cookieHelpers.setCookie(this.options.columnWidthCookie, JSON.stringify(columnWidths));
    },
    applyColumnWidths: function () {
        if (this.options.columnWidthCookie == null) {
            return;
        }

        let cookieVal = PJQ.helpers.cookieHelpers.getCookie(this.options.columnWidthCookie);

        if (!cookieVal) {
            return;
        }

        cookieVal = JSON.parse(cookieVal);

        if (cookieVal && cookieVal.length === this.$dataTable.find('thead th').length) {
            this.$dataTable.find('thead th').each(function (i) {
                $(this).css('width', cookieVal[i] + '%');
            });
            this.$dataTable.find('tbody tr').each(function () {
                $(this).find('td').each(function (i) {
                    $(this).css('width', cookieVal[i] + '%');
                });
            });
        }
    },
    beforeRemove: function () {
        $(window).off('resize.' + this.options.uuid);
    },
    pageCache: [],
    getPage: function (data, callback) {
        let pageNumber = 1,
            pageSize = data.length;
        if (data.start != null) {
            pageNumber = (data.start / pageSize) + 1;
        } else if (this.dataTable != null) {
            let pageInfo = this.dataTable.page.info();
            pageNumber = pageInfo.page + 1;
        }
        if (this.clearServerCache) {
            this.clearServerCache = false;
            this.pageCache = [];
        }

        if (this.pageCache[pageNumber - 1] == null) {
            let orderArr = [];
            _.each(data.order, function (order) {
                let columnOrderName = data.columns[order.column].data;
                if (_.size(columnOrderName) > 0 && columnOrderName.indexOf('attributes.') !== -1) {
                    columnOrderName = columnOrderName = columnOrderName.substr(columnOrderName.indexOf('.') + 1);
                }
                orderArr.push({
                    name: columnOrderName,
                    direction: order.dir
                });
            });
            let cache = this.pageCache;
            this.options.getPageCallback(pageNumber, pageSize, orderArr, _.bind(function (rows, rowCount) {
                //Its the first page, lets set the total count from the callback result
                if (pageNumber === 1) {
                    this.totalRows = rowCount;
                }
                cache[pageNumber - 1] = {
                    recordsTotal: this.totalRows,
                    recordsFiltered: this.totalRows,
                    data: rows
                };
                callback(cache[pageNumber - 1]);
            }), this);
        } else {
            callback(this.pageCache[pageNumber - 1]);
        }
    },
    afterDataTableRender: function () {
        if (typeof this.options.afterDataTableRender === 'function') {
            this.options.afterDataTableRender(this.dataTable);
        }
    },
    getColumns: function () {
        return this.options.columns;
    },
    orderByChanged: function () {
        if (typeof this.options.orderByChanged === 'function') {
            this.options.orderByChanged(...arguments);
        }
    },
    columnOrderChanged: function () {
        if (typeof this.options.columnOrderChanged === 'function') {
            this.options.columnOrderChanged(...arguments);
        }
    },
    createdRow: function (row, data) {
        if (typeof this.options.createdRow === 'function') {
            this.options.createdRow(row, data);
        }
    },
    getRow: function (obj) {
        if (this.dataTable) {
            if (typeof obj === 'object' && obj[0]) {
                let t = $(obj);
                if (t.length > 0) {
                    obj = t;
                }
            }

            if (obj instanceof $) {
                if (!obj.is('tr')) {
                    obj = obj.closest('tr');
                }
                obj = '#' + obj.attr('id');
            } else if (typeof obj === 'number' || typeof obj === 'string')
                obj = ('#' + obj.toString());
            return this.dataTable.row(obj);
        }
        return null;
    },
    addRow: function (obj) {
        if (this.dataTable != null) {
            if (PJQ.helpers.objectHelpers.refinedType(obj) === 'array') {
                this.dataTable.rows.add(obj).draw(false);
            } else {
                this.dataTable.row.add(obj).draw(false);
            }
        }
    },
    refreshRow: function (row) {
        if (typeof row.remove !== 'function') {
            row = this.getRow(row);
        }

        this.dataTable.row(row).invalidate().draw();
    },
    resetData: function (data) {
        this.options.data = data;
        this.dataTable.clear();
        this.dataTable.rows.add(this.getFilterData());
        this.search();
    },
    removeRow: function (row, isRefresh = true) {
        if (typeof row.remove !== 'function') {
            row = this.getRow(row);
        }

        row.remove();
        if (isRefresh) {
            this.refresh();
        }

        if (typeof this.options.onRowRemoved === 'function') {
            this.options.onRowRemoved(row);
        }
    },
    removeAllRows: function () {
        if (this.dataTable != null) {
            this.dataTable.clear();
        }
    },
    getFilterData: function () {
        return typeof this.options.getFilterData === 'function' ? this.options.getFilterData(this, this.options.data) : this.options.data;
    },
    getFilter: function (attr) {
        if (this.filters == null) {
            return null;
        }
        let find = this.filters[attr];
        return find ? find : null;
    },
    setFilter: function (attr, value) {
        if (this.filters == null) {
            this.filters = {};
        }
        this.filters[attr] = value;
        this.filter();
    },
    filter: function () {
        if (this.dataTable != null) {
            if (this.options.getPageCallback != null) {
                this.clearServerCache = true;
                this.dataTable.draw();
            } else {
                this.dataTable.clear();
                this.filteredData = this.getFilterData();
                this.dataTable.rows.add(this.filteredData);
                this.search();
            }
        }
    },
    clearFilters: function () {
        this.filters = null;
        this.renderHeader();
        this.filter();
    },
    getFilteredRowData: function () {
        let filteredRows = this.dataTable.rows({filter: 'applied'}).data(),
            result = [];
        _.each(filteredRows, function (filteredRow) {
            result.push(filteredRow);
        })
        return result;
    },
    toggleGroup: function (e) {
        let name = $(e.currentTarget).data('name');
        this.options.collapsedGroups[name] = !this.options.collapsedGroups[name];
        this.dataTable.draw();
    },
    getGroupByColumnIndex: function (id) {
        let result = _.findIndex(this.options.columns, function (col) {
            return col.attribute === id || col.columnData === id;
        })
        return result === -1 ? null : result;
    },
    getGroupByColumn: function () {
        let colInd = this.getGroupByColumnIndex(this.getGroupBy());
        col = colInd != null ? this.options.columns[colInd] : null;
        return col ? {
            column: col,
            index: colInd
        } : null;
    },
    getGroupBy: function () {
        return typeof this.options.groupBy !== 'undefined' ? this.options.groupBy : null;
    },
    setGroupBy: function (groupBy) {
        this.options.groupBy = groupBy;

        if (_.size(this.options.groupByKey) > 0) {
            window.localStorage.removeItem(this.Key_Access_Token);
            if (_.size(groupBy) > 0) {
                window.localStorage.setItem(this.options.groupByKey, groupBy);
            }
        }

        this.render();
    },
    startGroupRender: function (rows, group) {
        if (group == null) {
            return;
        }

        let collapsed = !!this.options.collapsedGroups[group];

        rows.nodes().each(function (r) {
            r.style.display = collapsed ? 'none' : '';
        });

        let toggle = '';
        if (this.options.disableGroupToggle !== true) {
            let toggleClass = collapsed ? 'fa-plus-square' : 'fa-minus-square';
            toggle = `<span data-name="${group}" class="fal ml-2 mr-2 fa-lg fa-fw toggler ${toggleClass}" style="width:auto;"></span>`;
        }

        // Add group name to <tr>
        return $('<tr/>')
            .append('<td colspan="' + rows.columns()[0].length + '"><div class="d-flex wd-100 align-items-center">' + toggle + '<div class="wd-100" style="display:inherit;">' + this.getGroupHeader(group, rows) + '</div></div></td>').attr('data-name', group)
            .toggleClass('collapsed', collapsed);
    },
    getGroupHeader: function (group, rows) {
        if (typeof this.options.getGroupHeader === 'function') {
            return this.options.getGroupHeader(group, rows);
        }

        return '<span class="fs-15 font-weight-bold text-dark p-1">' + group + ' (' + rows.count() + ')</span>';
    },
    refresh: function (type = false) {
        if (this.dataTable != null) {
            this.dataTable.rows().invalidate(type);
            this.adjust(type);
            this.onTableDraw();
        }
    },
    adjust: function (type = false) {
        this.dataTable.columns.adjust().draw(type);
    },
    getSearchText: function () {
        let $search = this.$('.datatable-search');
        return $search.length > 0 ? $search.val() : '';
    },
    search: function (searchText) {
        searchText = this.getSearchText();
        //Hack to make the zeroRecords language be used instead of emptyTable
        //This is only needed when there are records filtered before the search
        //If the remaining records are filtered by search, the datatable will handle the language correctly
        if (this.options.getPageCallback != null) {
            if (this.lastSearchText !== searchText) {
                if (this.searchTimeout != null) {
                    clearTimeout(this.searchTimeout);
                }
                this.searchTimeout = setTimeout(_.bind(function () {
                    this.clearServerCache = true;
                    this.dataTable.search(searchText).draw();
                    this.afterSearch();
                }, this), 500);
            }
        } else {
            let colSearch = false;
            if (searchText.indexOf(":") !== -1) {
                let searchArr = searchText.split(':');
                if (_.size(searchArr) > 1) {
                    let colName = searchArr[0],
                        colSearchText = searchArr[1],
                        colIndex = this.colNameMap[colName.toLowerCase()];
                    if (colIndex != null) {
                        colSearch = true;
                        this.dataTable.search('').column(colIndex).search(colSearchText).draw();
                    }
                }
            }
            if (!colSearch) {
                this.dataTable.columns().search('');
                this.dataTable.search(searchText).draw();
            }

            //If there is a filter prior to the search, we have to override the emptyTable language with zeroRecords
            //zeroRecords is only displayed automatically using DataTables built in search
            if (_.size(searchText) === 0 && _.size(this.filteredData) === 0 && _.size(this.options.data) > 0) {
                this.$(".dataTables_empty").html(this.options.language.zeroRecords);
            }
            this.initializeToggledRows();
            this.afterSearch();
        }
        this.lastSearchText = searchText;
    },
    afterSearch: function () {

    },
    addContextMenu: function (newOptions) {
        this.options.contextMenuOptions = newOptions;
        this.contextMenu = new PJQ.menus.ContextMenu(_.defaults(this.options.contextMenuOptions, {
            el: this.$wrapper,
            selector: 'tr[id]:not(.child-row)',
            isHideNoActions: true,
            isWrapInFixedContainer: true,
            fetchElementData: _.bind(function (element) {
                return this.getRow(element);
            }, this),
            onOpen: _.bind(function (row) {
                $(row.node()).addClass('context-row');
            }, this),
            onClose: _.bind(function () {
                this.$('.context-row').removeClass('context-row');
            }, this)
        }));
    },
    makeSortable: function (options) {
        let data = this.dataTable.data();
        if (_.size(data) === 0) {
            return;
        }

        let self = this;
        this.options.sortableOptions = options;

        if (this.options.sortableOptions.isNestedTable) {
            new PJQ.Sortable(self.$el, _.defaults(this.options.sortableOptions, {
                data: data[0].collection,
                dataAttribute: 'sortOrder',
                items: 'tbody tr:not(.child-row-footer)',
                connectWith: 'tbody tr:not(.child-row-footer)',
                start: function (event, ui) {
                    $(this).sortable("refreshPositions");
                },
                change: function (event, ui) {
                    let placeholder = ui.placeholder,
                        prevItem = placeholder.prev(),
                        nextItem = placeholder.next(),
                        draggedItem = ui.helper;

                    if (draggedItem.hasClass('child-row')) {
                        let level = draggedItem.data('level');
                        if (!((nextItem.hasClass('child-row') || nextItem.hasClass('child-row-footer')) && nextItem.data('level') === level)) {
                            placeholder.hide();
                            return;
                        }
                    } else {
                        if (!(prevItem.data('parentId') == null || prevItem.length === 0)) {
                            placeholder.hide();
                            return;
                        }
                    }

                    placeholder.show();
                },
                stop: function (event, ui) {
                    let draggedItem = ui.item,
                        level = draggedItem.data('level'),
                        parentId,
                        prevItem = draggedItem.prev();

                    if (level != null) {
                        // If the next item is not a child-row or child-row-footer, and it's level is not the same as the dragged item, then cancel the drop
                        let nextItem = draggedItem.next();
                        if (!((nextItem.hasClass('child-row') || nextItem.hasClass('child-row-footer')) && nextItem.data('level') === level)) {
                            $(this).sortable('cancel');
                            return;
                        }

                        // If the dragged elements level is 1, then we need to find the first element above it that doesn't have a level
                        // If the dragged elements level is greater than 1, then we need to find the first element above it that has a level 1 less than the dragged element
                        // The parentId will be the id of the element found that meets the above criteria
                        if (level === 1 || level == null) {
                            while (prevItem.length) {
                                if (!prevItem.data('level')) {
                                    parentId = prevItem.attr('id');
                                    break;
                                }
                                prevItem = prevItem.prev();
                            }
                        } else {
                            while (prevItem.length) {
                                if (prevItem.data('level') === level - 1) {
                                    parentId = prevItem.attr('id');
                                    break;
                                }
                                prevItem = prevItem.prev();
                            }
                        }

                        if (!parentId) {
                            $(this).sortable('cancel');
                            return;
                        }

                        draggedItem.attr('data-parent-id', parentId).data('parent-id', parentId);
                        let siblings = self.$dataTable.find('tbody tr').filter(function () {
                            return $(this).data('parent-id') === parentId && !$(this).hasClass('child-row-footer');
                        });
                        let position = siblings.index(draggedItem) + 1;

                        let item,
                            parent;

                        _.each(options.data, function (data) {
                            if (data.cid === draggedItem.attr('id')) {
                                item = data;
                            }

                            if (data.cid === parentId) {
                                parent = data;
                            }
                        });

                        if (item == null || parent == null || position <= 0) {
                            $(this).sortable('cancel');
                            return;
                        }

                        self.onNestedRowSorted(item, position, parent);
                    } else {
                        if (!(prevItem.data('parentId') == null || prevItem.length === 0)) {
                            $(this).sortable('cancel');
                            return;
                        }

                        let siblings = self.$dataTable.find('tbody tr').filter(function () {
                            return !$(this).data('parent-id');
                        });

                        let position = siblings.index(draggedItem) + 1,
                            item = _.find(options.data, (data) => data.cid === draggedItem.attr('id'));

                        if (item == null || position <= 0) {
                            $(this).sortable('cancel');
                            return;
                        }

                        self.onNestedRowSorted(item, position, null);
                    }
                }
            }));
        } else {
            new PJQ.Sortable(self.$('table'), _.defaults(this.options.sortableOptions, {
                containment: "document",
                data: data[0].collection,
                dataAttribute: 'sortOrder',
                items: ".even, .odd",
                connectWith: ".even, .odd",
                // Start is necessary to keep row CSS from squishing together
                // Selects the table header row and copies the width of the td to the current dragged object
                start: _.bind(function (a, b) {
                    let headerRow = self.$('thead')[0].firstChild;
                    _.each(b.item[0].children, function (td, index) {
                        if ($(headerRow.children[index])[0]) {
                            td.width = $(headerRow.children[index])[0].style.width
                        }
                    })
                }),
                stop: _.bind(function (a, b) {
                    let sortedRow = b.item[0].id,
                        rowData = options.data.get(sortedRow),
                        pageInfo = self.dataTable.page.info();
                    self.$('tr').filter('.odd, .even').each(function (index, html) {
                        let sortNumber = (pageInfo.page * pageInfo.length) + (index + 1);
                        let row = $(html)[0].id;
                        if (row === sortedRow) {
                            self.onRowSorted(rowData, sortNumber);
                        }
                    });
                }, this)
            }));
        }
    },
    onNestedRowSorted: function (item, newSort, newParent) {
        if (typeof this.options.onNestedRowSorted === 'function') {
            this.options.onNestedRowSorted(item, newSort, newParent);
        }
    },
    onRowSorted: function (data, sortOrder) {
        if (data == null || _.size(this.options.sortableOptions.dataAttribute) === 0) {
            return;
        }

        data.set(this.options.sortableOptions.dataAttribute, sortOrder);

        if (this.options.sortableOptions.shouldSave !== false) {
            data.save(null, {
                success: _.bind(function () {
                    if (this.collection != null) {
                        this.collection.fetch({
                            success: _.bind(function () {
                                this.render();
                            }, this)
                        });
                    }
                }, this)
            });
        }
    },
    toggleAllChildRows: function (e) {
        let self = this,
            expand = _.size(this.expandedRowIds) === 0;
        this.dataTable.rows().every(function () {
            self.toggleChildRow(this, expand);
        });
        this.renderToggleAllIcon();
    },
    renderToggleAllIcon: function () {
        let $icon = $('.toggle-all-rows');
        if ($icon.length === 0) {
            return;
        }

        let hasExpanded = _.size(this.expandedRowIds) > 0;
        if (hasExpanded) {
            $icon.removeClass('fa-plus-circle').addClass('fa-minus-circle');
        } else {
            $icon.removeClass('fa-minus-circle').addClass('fa-plus-circle');
        }
    },
    childRowToggle: function (sender, rowOverride) {
        let $target = rowOverride ? $(rowOverride.selector.rows).find(this.options.toggleRowClass) : $(sender.currentTarget),
            id = $target.data('id'),
            tr = $target.closest('tr'),
            row = this.getRow(tr);
        this.toggleChildRow(row);
    },
    toggleChildRow: function (row, show = null, preventOnToggleEvent = false) {
        if (this.expandedRowIds == null) {
            this.expandedRowIds = [];
        }

        let tr = $(row.node()),
            item = row.data(),
            id = item[this.options.rowId],
            $icon = tr.find(this.options.toggleRowClass),
            level = tr.data('level');
        if (show !== true && (row.child.isShown() || tr.hasClass('shown') || this.expandedRowIds.includes(id))) {
            // This row is already open - close it
            if (this.options.childDataTables != null) {
                this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                    return childDt.options.parentId !== id;
                }, this));
            }

            row.child.hide();
            tr.removeClass('shown');
            this.expandedRowIds = this.expandedRowIds.filter(expandedId => expandedId !== id);
            $icon.removeClass('fa-minus-circle').addClass('fa-plus-circle');

            let parentId = item[this.options.rowId];
            if (_.size(parentId) > 0) {
                let childRows = this.$('tr.child-row[data-parent-id="' + parentId + '"], tr.child-row-footer[data-parent-id="' + parentId + '"], tr.child-row-header[data-parent-id="' + parentId + '"]');
                if (_.size(childRows) > 0) {
                    childRows.remove();
                }
            }
        } else if (show !== false) {
            $icon.removeClass('fa-plus-circle').addClass('fa-minus-circle');

            this.renderChildRows(row, id, level ? level + 1 : 1);
            tr.addClass('shown');
            this.expandedRowIds.push(id);
        }

        if (!preventOnToggleEvent) {
            this.onChildRowToggle(row);
        }
        this.renderToggleAllIcon();
    },
    onChildRowToggle: function (row) {
        if (typeof this.options.onChildRowToggle === 'function') {
            this.options.onChildRowToggle(row);
        }
    },
    initializeToggledRows: function () {
        let expandAll = this.expandedRowIds == null && this.options.expandAll;
        if (_.size(this.expandedRowIds) === 0 && !expandAll)
            return;

        let self = this;
        this.dataTable.rows().every(function (rowIdx, tableLoop, rowLoop) {
            let row = this,
                data = row.data(),
                id = data[self.options.rowId];
            if (expandAll || _.contains(self.expandedRowIds, id)) {
                self.toggleChildRow(row, true, true);
            }
        });
    },
    getChildHeader: function (opts) {
        if (typeof this.options.getChildHeader === 'function') {
            return this.options.getChildHeader(opts);
        }
        return '';
    },
    getChildFooter: function (opts) {
        if (typeof this.options.getChildFooter === 'function') {
            return this.options.getChildFooter(opts);
        }
        return '';
    },
    renderChildRows: function (row, parentId, level = 1) {
        if (this.childRows == null) {
            this.childRows = {};
        }

        if (!this.childRows[level]) {
            this.childRows[level] = {};
        }

        let childData = this.getRowChildData(row);
        if (childData != null) {
            let fnRender = _.bind(function () {
                let childCols = this.getRowChildColumns({
                    level: level
                });
                if (childCols != null) {
                    let childRows = '';

                    let childHeader = this.getChildHeader(row);
                    if (_.size(childHeader) > 0) {
                        let displayedColumnsCount = this.dataTable.columns(':visible').count();
                        childRows += `<tr><td style="border-top: none;" colspan="${displayedColumnsCount}"><table class="wd-100 table dataTable no-footer"><tr class="child-row-header" data-level="${level}" data-parent-id="${parentId}">${childHeader}</tr>`;
                    }

                    childData.forEach((item) => {
                        childRows += this.renderChildRow(parentId, item, level, childCols);
                    });

                    let footer = this.getChildFooter(row);
                    if (_.size(footer) > 0) {
                        childRows += `<tr class="child-row-footer" data-level="${level}" data-parent-id="${parentId}">${footer}</tr>`;
                    }

                    if (_.size(childHeader) > 0) {
                        childRows += '</table></td></tr>';
                    }

                    $(row.node()).after(childRows);
                    return;
                }

                let childClass = 'subgrid-' + parentId.toString(),
                    $childTable = $('<div data-id="' + parentId + '" />', {
                        class: childClass + ' p-2'
                    });
                row.child($childTable).show();
                let childTable = this.getRowChildTable({
                    el: $childTable,
                    data: PJQ.helpers.objectHelpers.isBackboneCollection(childData) ? childData.models : childData,
                    isHideSearch: true,
                    parentId: parentId,
                    parentData: row.data()
                });
                this.options.childDataTables = _.filter(this.options.childDataTables, _.bind(function (childDt) {
                    return childDt.options.parentId !== parentId;
                }, this));
                this.options.childDataTables.push(childTable);
            }, this);

            if (PJQ.helpers.objectHelpers.isBackboneModel(childData)) {
                childData.fetch({
                    success: _.bind(function () {
                        // loader.remove();
                        fnRender();
                    }, this)
                });
            } else {
                fnRender();
            }
        }
    },
    renderChildRow: function (parentId, item, level, cols = null, replace = false) {
        if (cols == null) {
            cols = this.getRowChildColumns({
                level: level
            });
        }

        let row = `<tr data-parent-id="${parentId}" data-level="${level}" data-row-id="${item.cid}" id="${item.cid}" class="child-row">`;
        cols.forEach((column, index) => {
            let content = typeof column.render === 'function' ? column.render(null, null, item) : '';
            row += `<td style="width:${column.width || 'auto'}">${content}</td>`;
        });
        row += '</tr>';

        if (replace) {
            let $row = this.$('tr.child-row[data-row-id="' + item[this.options.rowId] + '"]');
            if ($row.length > 0) {
                $row.replaceWith(row);
            } else {

            }
        }

        return row;
    },
    renderChildColumn: function (colIndex, item, level) {
        let cols = this.getRowChildColumns({
                level: level
            }),
            column = cols[colIndex];
        if (column == null) {
            return;
        }

        let content = typeof column.render === 'function' ? column.render(null, null, item) : '',
            $row = this.$('tr.child-row[data-row-id="' + item[this.options.rowId] + '"]');
        if ($row.length === 0) {
            return;
        }

        let $replace = $row.find('td:nth-child(' + (colIndex + 1).toString() + ')');
        if ($replace.length === 0) {
            return;
        }
        $replace.replaceWith(`<td style="width:${column.width || 'auto'}">${content}</td>`);
    },
    getRowChildColumns: function (opts) {
        if (typeof this.options.getRowChildColumns === 'function') {
            return this.options.getRowChildColumns(opts);
        }
        return null;
    },
    getRowChildTable: function (opts) {
        if (typeof this.options.getRowChildTable === 'function') {
            return this.options.getRowChildTable(opts);
        }
        return null;
    },
    getRowChildData: function (row) {
        if (typeof this.options.getRowChildData === 'function') {
            return this.options.getRowChildData(row);
        }
        return {};
    },
    copyPhone: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('phone'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Number copied to clipboard.'
        });
    },
    copyEmail: function (e) {
        let inputId = 'h_input_' + _.uniqueId(),
            hiddenInput = $('<input>', {
                value: $(e.currentTarget).data('email'),
                style: 'position: absolute;left:-2000px;top:-2000px',
                id: inputId
            });
        this.$el.append(hiddenInput);
        hiddenInput[0].select();
        document.execCommand("copy");
        hiddenInput.remove();
        PJQ.notifications.notify.successNotify({
            message: 'Email copied to clipboard.'
        });
    }
});
